import React from "react";
import { useTranslation } from "react-i18next";
import { RouteAdmin } from "../../../routes/RouteAdmin";
import { Link, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import './MenuHeaderLeft.css';
import { ChevronDown } from "lucide-react";
import { Building, Trello, DollarSign, Users, Truck } from "lucide-react"; // Añade tus importaciones

export default function MenuHeaderLeft(props) {
    const {t} = useTranslation()
    const {menu} = props
    const { auth } = useAuth()
    const role = auth ? auth.primaryUser.role : null

    return (
        /* USAMOS LA CLASE CSS para el contenedor */
        <div className="menu-navigation-container">       
            {role ==="ROLE_ADMIN" ? (
                <>
                    <DropdownMenu
                        title="Organización"
                        IconComponent={Building}
                        showArrow={false}
                        items={[
                            { to: RouteAdmin.ORGANIZATIONS_MANAGEMENT.path, label: "Organización" },
                            { to: RouteAdmin.TIPO_SERVICIOS_MANAGEMENT.path, label: "Servicios" },
                            { to: RouteAdmin.GESTION_GEOGRAFICA.path, label: "Zonas" },
                            { to: RouteAdmin.USER_MANAGEMENT.path, label: "Usuarios" }
                        ]}
                    />

                    <DropdownMenu
                        title="Operaciones"
                        IconComponent={Trello}
                        showArrow={false}
                        items={[
                            { to: RouteAdmin.CALENDARIO_MANAGEMENT.path, label: "Calendario" },
                            { to: RouteAdmin.TRABAJOS_MANAGEMENT.path, label: "Trabajos" }
                        ]}
                    />

                    <DropdownMenu
                        title="Ventas"
                        IconComponent={DollarSign}
                        showArrow={false}
                        items={[
                            { to: RouteAdmin.PRESUPUESTO_MANAGEMENT.path, label: "Presupuesto" },
                            { to: RouteAdmin.FACTURAS_MANAGEMENT.path, label: "Factura" },
                            { to: RouteAdmin.SIMPLE_INVOICE_MANAGEMENT.path, label: "Factura simple" },
                            { to: RouteAdmin.TICKETS_MANAGEMENT.path, label: "Ticket" },
                            { to: RouteAdmin.DELIVERY_NOTE_MANAGEMENT.path, label: "Albarán" },
                        ]}
                    />

                    <DropdownMenu
                        title="HHRR"
                        IconComponent={Users}
                        showArrow={false}
                        items={[
                            { to: RouteAdmin.MEDIA_MANAGEMENT.path, label: "Documentación" },
                        ]}
                    />

                    <DropdownMenu
                        title="Proveedores"
                        IconComponent={Truck}
                        showArrow={false}
                        items={[
                            { to: RouteAdmin.PROVIDER_MANAGEMENT.path, label: "Alta" },
                            { to: RouteAdmin.PROVIDER_RECORD_MANAGEMENT.path, label: "Facturas" }
                        ]}
                    />
                </>
            ) : (
                <>
                    <MenuLink type="organization" menu={menu} to={RouteAdmin.ORGANIZATIONS_MANAGEMENT.path} name="Organizaciones"/>
                    <MenuLink type="calendario" menu={menu} to={RouteAdmin.CALENDARIO_MANAGEMENT.path} name="Calendario"/>
                    <MenuLink type="trabajos" menu={menu} to={RouteAdmin.TRABAJOS_MANAGEMENT.path} name="Trabajos"/>
                    <MenuLink type="gestionGeografica" menu={menu} to={RouteAdmin.GESTION_GEOGRAFICA.path} name="Gestión geográfica"/>
                    <MenuLink type="media" menu={menu} to={RouteAdmin.MEDIA_MANAGEMENT.path} name="Documentación"/>
                </>
            )}
        </div>
    )
}

function MenuLink(props) {
    const {to, name, menu, type} = props

    let isActive = false
    if (menu === type) {
        isActive = true
    }

    return (
        <>
            <div style={{marginRight: '25px'}}>
                <Link
                    to={to}
                    className={isActive ? 'active' : ''}
                >
                    {name}
                </Link>
            </div>
        </>
    )
}

// Aceptamos la nueva prop 'showArrow' y le asignamos un valor por defecto (true)
function DropdownMenu({ title, items, IconComponent, showArrow = true }) { 
    const [open, setOpen] = React.useState(false);
    const location = useLocation();
    const isActive = items.some(item => location.pathname === item.to);

    return (
        <div
            className={`dropdownMenu ${open ? "open" : ""}`}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <span className={`dropdownMenu-title${isActive ? " active" : ""}`}>
                
                {/* Renderizado del Icono principal */}
                {IconComponent && <IconComponent size={18} strokeWidth={2} style={{ marginRight: '4px', marginTop: "-10px" }} />}
                
                {title}
                
                {/* 🎯 Renderizado Condicional de la Flecha */}
                {showArrow && (
                    <ChevronDown
                        size={18}
                        strokeWidth={2}
                        className={`dropdownMenu-icon ${open ? "open" : ""}`}
                        style={{ marginTop: "-7px"}}
                    />
                )}
            </span>

            <div className={`dropdownMenu-content ${open ? "open" : ""}`}>
                {items.map((item, idx) => (
                    <Link
                        key={idx}
                        to={item.to}
                        className="dropdownMenu-item"
                    >
                        {item.label}
                    </Link>
                ))}
            </div>
        </div>
    );
}